import type { RemoteModule, TenantAdminRemoteProps } from './types';

type LocalRemoteModule = RemoteModule<Record<string, never>> | RemoteModule<TenantAdminRemoteProps>;

const localRemoteLoaders = {
  'tenant-web-workspace/App': () => import('@/modules/workspace/remote-unavailable').then(module => ({ default: module.WorkspaceRemoteUnavailable })),
  'tenant-web-admin/App': () => import('@/modules/admin/remote-unavailable').then(module => ({ default: module.AdminRemoteUnavailable })),
  'tenant-web-hr-workspace/App': () => import('@/modules/hr/workspace/remote-unavailable').then(module => ({ default: module.HrWorkspaceRemoteUnavailable })),
  'tenant-web-hr-admin/App': () => import('@/modules/hr/admin/remote-unavailable').then(module => ({ default: module.HrAdminRemoteUnavailable })),
} satisfies Record<string, () => Promise<LocalRemoteModule>>;

export type LocalRemoteName = keyof typeof localRemoteLoaders;

export function hasLocalRemote(remoteName: string): remoteName is LocalRemoteName {
  return remoteName in localRemoteLoaders;
}

export function loadLocalRemote(remoteName: LocalRemoteName) {
  return localRemoteLoaders[remoteName]() as Promise<LocalRemoteModule>;
}
